import { ApiAnswer } from "context/reportUserNotesAnswers";
import { useTranslator } from "hooks/useTranslator";
import { apiAnswersToAnswersMap } from "lib/userApiAnswersToAnswerMap.lib";

export const useApiAnswersToAnswersMap = () => {
  const translator = useTranslator();

  return (apiAnswers: Array<ApiAnswer>) => apiAnswersToAnswersMap(apiAnswers, translator);
};
